import Default from "./VariableCellIcon";
export * from "./VariableCellIcon";

export default Default;
